import {
    useDevAiIntent,
    useJiraIntent,
    useJiraServiceManagementIntent
} from "@/components/user-context";

import { LoggedInDevAI } from "./devai/logged-in-devai";
import { LoggedInJira } from "./jira/logged-in-jira";
import { LoggedInJiraServiceManagement } from "./jira-service-management/logged-in-jira-service-management";
import { LoggedInDefault } from "./logged-in-default";

export const LoggedIn = () => {
    // TO DO: add other products in here & default case
    const isJira = useJiraIntent();
    const isJSM = useJiraServiceManagementIntent();
    const isDevAI = useDevAiIntent();

    if (isJira) {
        return <LoggedInJira />;
    }

    if (isJSM) {
        return <LoggedInJiraServiceManagement />;
    }

    if (isDevAI) {
        return <LoggedInDevAI />;
    }

    return <LoggedInDefault />;
};
